const rateFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'percentage' implicitly has an 'any' type.
export const roundDecimal = (percentage, digits = 2) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(percentage)) {
    return 0;
  }
  return Number(percentage.toFixed(digits));
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'number' implicitly has an 'any' type.
export const renderNumber = (number) => (number ? Number(number).toFixed(2) : "0.00");

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'amount' implicitly has an 'any' type.
export const renderAmount = (amount) =>
  amount >= 0
    ? `$${roundUpAndFormatRateWithZeroes(amount)}`
    : `-$${roundUpAndFormatRateWithZeroes(-amount)}`;

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'amount' implicitly has an 'any' type.
export const renderCentsAmount = (amount) => `$${renderNumber(amount / 100)}`;

const formatRateWithZeroes = (rate?: number): string => {
  if (rate === undefined) {
    return "";
  }
  return rateFormatter.format(rate);
};

const roundUpRateToNearestCent = (rate: number) => {
  if (Number.isNaN(Number(rate))) {
    return 0;
  }
  const multiplier = 100;
  // to fix weird decimal like 69.18 * 100 = 6918.000000000001
  const fixEpsilonDecimal = (rate * multiplier).toFixed(10);
  return Math.ceil(Number(fixEpsilonDecimal)) / multiplier;
};

export const roundUpAndFormatRateWithZeroes = (rate: number): string => {
  return formatRateWithZeroes(roundUpRateToNearestCent(rate));
};
